// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"188":"58014027","240":"43565e2a","279":"412c6b1d","900":"9706779e"}[chunkId] + ".css";
};